import { knowledgebaseService } from "../_services";

let decreeStateList = [
  { value: 0, text: "Оставлено без изменения" },
  { value: 1, text: "Отменено" },
  { value: 2, text: "Изменено" }
];

let typeList = [
  { value: 0, text: "Гражданские" },
  { value: 1, text: "Административные" },
  { value: 2, text: "Уголовные" },
  { value: 3, text: "КоАП" }
];

let sortList = {
  byYear:[
    { field: "date", direction: "desc", text: "по дате публикации" },
    { field: "year", direction: "asc", text: "по году (возрастание)" },
    { field: "year", direction: "desc", text: "по году (убывание)" }
  ],
  byTitle:[
    { field: "date", direction: "desc", text: "по дате публикации" },
    { field: "clause", direction: "asc", text: "по названию (от а до я)" },
    { field: "clause", direction: "desc", text: "по названию (от я до а)" }
  ]
};

let filter = {
  year: null,
  type: null,
  sort: { field: "date", direction: "desc", text: "по дате публикации" },
  category: null,
  date:null,
  searchText: null,
  page: 1,
  perPage: 10
};

export default {
  namespaced: true,

  state: {
    // data
    knowledgeCategory: [],
    knowledgeDocs: [],

    decreeStateList,
    typeList,
    sortList,
    filter,
    totalPages: 0
  },

  getters: {
    gKnowledgeCategory({ knowledgeCategory }) {
      return knowledgeCategory;
    },
    gKnowledgeDocs({ knowledgeDocs }) {
      return knowledgeDocs;
    },
    gDecreeStateList() {
      return decreeStateList;
    },
    gTypeList() {
      return typeList;
    },
    gFilter() {
      return filter;
    }
  },

  mutations: {
    setKnowledgeCategory: (state, payload) => {
      state.knowledgeCategory = payload.map(item => ({ ...item }));
    },

    setKnowledgeDocs: (state, payload) => {
      state.knowledgeDocs = payload.map(item => ({ ...item }));
    },

    /*addKnowledgeDoc: (state, payload) => {
      state.knowledgeDocs.push(payload); 
    },

    editKnowledgeDoc: (state, payload) => {
      state.knowledgeDocs = state.knowledgeDocs.map(f =>
        f.id === payload.id ? payload : f
      );
    },*/

    mSetPage: (state, payload) => {
      state.filter.page = payload;
    },

    mSetType: (state, payload) => {
      state.filter.type = payload;
    },

    mSetYear: (state, payload) => {
      state.filter.year = payload;
    },

    mSetCategory: (state, payload) => {
      if (payload)
        state.filter.category = {
          id: payload.id,
          alias: payload.alias,
          title: payload.title,
          sort: payload.sort
        };
      else state.filter.category = null;
      state.filter.page = 1;
    },

    mSetPeriod: (state, payload) => {
      state.filter.page = 1;
      if (payload) {
        payload.start = payload.start+' 00:00'
        payload.end = payload.end+' 00:00'
      }
      state.filter.date = payload;
    },

    mSetSort: (state, payload) => {
      state.filter.page = 1;
      state.filter.sort = payload;
    },

    mSearchText: (state, payload) => {
      state.filter.page = 1;
      state.filter.searchText = payload;
    },

    mSetFilter: (state, payload) => {
      state.filter = payload;
    },

    setTotalPages: (state, payload) => {
      state.totalPages = payload;
    }
  },

  actions: {
    init: ({ dispatch }) => {
      dispatch("getKnowledgeCategory");
      //dispatch("getKnowledgeDocs");
    },

    setPage: ({ commit, dispatch }, payload) => {
      commit("mSetPage", payload);
      dispatch("getKnowledgeDocs");
    },

    setType: ({ commit, dispatch }, payload) => {
      let ft = null;
      if (payload.value > -1) ft = payload;
      commit("mSetType", ft);
      commit("mSearchText", null);
      dispatch("getKnowledgeDocs");
    },

    setYear: ({ commit, dispatch }, payload) => {
      let y = null;
      if (payload === "все") y = null;
      else y = payload;
      commit("mSetYear", y);
      commit("mSearchText", null);
      dispatch("getKnowledgeDocs");
    },

    setCategory: ({ commit, dispatch }, payload) => {
      commit("mSetFilter", {
        year: null,
        type: null,
        sort: { field: "date", direction: "desc", text: "по дате публикации ↓" },
        category: null,
        date:null,
        searchText: null,
        page: 1,
        perPage: 10
      });
      commit("mSetCategory", payload);
      dispatch("getKnowledgeDocs");
    },

    setPeriod: ({ commit, dispatch }, payload) => {
      commit("mSetPeriod", payload);
      commit("mSearchText", null);
      dispatch("getKnowledgeDocs");
    },

    setSort: ({ commit, dispatch }, payload) => {
      commit("mSetSort", payload);
      commit("mSearchText", null);
      dispatch("getKnowledgeDocs");
    },

    setSearchText: ({ commit, dispatch, state }, payload) => {
      let cat = null;
      if (state.filter.category) cat = state.filter.category;
      else cat = {
             id: state.knowledgeCategory[0].id,
             alias: state.knowledgeCategory[0].alias,
             title: state.knowledgeCategory[0].title,
             sort: state.knowledgeCategory[0].sort
           };
      commit("mSetFilter", {
        year: null,
        type: null,
        sort: { field: "date", direction: "desc", text: "по дате публикации ↓" },
        category: cat,
        searchText: null,
        page: 1,
        perPage: 10
      });
      commit("mSearchText", payload);
      dispatch("getKnowledgeDocs");
    },

    setFilter: ({ commit, dispatch }, payload) => {
      commit("mSetFilter", payload);
      dispatch("getKnowledgeDocs");
    },

    clearFilter: ({ commit, dispatch }) => {
      commit("mSetFilter", {
        year: null,
        type: null,
        sort: { field: "date", direction: "desc", text: "по дате публикации ↓" },
        category: null,
        date:null,
        searchText: null,
        page: 1,
        perPage: 10
      });
      dispatch("getKnowledgeDocs");
    },

    getKnowledgeCategory: ({ commit, dispatch }) => {
      knowledgebaseService.getKnowledgeCategory().then(data => {
        commit("setKnowledgeCategory", data || []);
        commit("mSetCategory", data[0] || null);
        dispatch("getKnowledgeDocs");
      });
    },

    getKnowledgeDocs: ({ commit, state }) => {
      knowledgebaseService.getKnowledgeDocs(state.filter).then(data => {
        commit("setKnowledgeDocs", data.content || []);
        commit("setTotalPages", data.totalPages || []);
      });
    },

    addKnowledgeDoc: ({ dispatch }, data) => {
      knowledgebaseService.addKnowledgeDoc(data).then(() => {
        //commit("addKnowledgeDoc", data || []);
        dispatch("getKnowledgeDocs");
      });
    },

    editKnowledgeDoc: ({ dispatch }, data) => {
      knowledgebaseService.editKnowledgeDoc(data).then(() => {
        //commit("editKnowledgeDoc", data || []);
        dispatch("getKnowledgeDocs");
      });
    },

    delKnowledgeDoc: ({ dispatch }, data) => {
      knowledgebaseService.delKnowledgeDoc(data).then(() => {
        dispatch("getKnowledgeDocs");
      });
    }

  }
};
